export default "__VITE_ASSET__378f8c33__"